import styles from "./ListingPage.css";
import config from "../../config/common";
import { Fragment } from "react";

const addAdvert = ({ advert, items }) => {
  const {
    adverts: { adPosition }
  } = config;

  if (advert) {
    items = [
      ...items.slice(0, adPosition),
      <Fragment key="advert">{advert({ className: styles.advert })}</Fragment>,
      ...items.slice(adPosition)
    ];
  }

  return {
    adPosition: advert ? adPosition : null,
    items: [...items]
  };
};

export default addAdvert;
